import React from "react";
import "../css/Grid.css";
import "../css/LandingPage.css";
import {userButton} from './UserButton.js';
import beacon from "../api/logClick.js";

const LandingPageHeader = ({ user, media }) => {
const beaconFriendlyUserId = user.userId.replace('userId#','');
 const ctaText = media?.landingPageCta?.trim() || "Open link";
  const href = media?.externalUrl;

//const cleanMediaId = `landingPageMediaId#${mediaId}`;


  const handle = `@${user.username}`;
  return (
    <header className="landing-page-header">
      <table>
        <tbody>
          <tr>
            {user.profilePicUrl !== undefined ? (
              <td>
                <img
                  src={user.profilePicUrl}
                  alt="Profile"
                  className="avatar"
                />
              </td>
            ) : null}
            <td>
              <p className="ig-handle">{handle}</p>
            </td>
          </tr>
        </tbody>
      </table>


      <p className="homepage-disclosure">{media.landingPageDisclosure}</p>
       <a
                  className={`standalone-cta ${!href ? "is-disabled" : ""}`}
                  href={href || undefined}
                  target="_self"
                  aria-disabled={!href}
                  tabIndex={href ? 0 : -1}
                  onClick={() => beacon(media.SK, beaconFriendlyUserId, href)}

                >
                  {ctaText}
                </a>
    </header>
  );
};

export default LandingPageHeader;
